<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from '#app/composables/router';
import { useAiContext } from '#layers/ai/composables/use-ai-context';
import { useUserLocale } from '#layers/base/public';
import { useTranslationUtils } from '#layers/i18n/public';

const route = useRoute();
const { language } = useUserLocale();
const { translateString } = useTranslationUtils();

const title = computed(() => {
	if (route.meta?.page?.title) {
		return translateString(route.meta.page.title);
	}

	if (route.meta?.settings?.title) {
		return translateString(route.meta.settings.title);
	}

	if (route.meta?.space?.title) {
		return translateString(route.meta.space.title);
	}

	return void 0;
});

const description = computed(() => {
	if (route.meta?.page?.description) {
		return translateString(route.meta.page.description);
	}

	if (route.meta?.settings?.description) {
		return translateString(route.meta.settings.description);
	}

	if (route.meta?.space?.description) {
		return translateString(route.meta.space.description);
	}

	return void 0;
});

useAiContext(computed(() => {
	return [
		{
			id: 'locale',
			title: 'User preferred locale',
			value: language.value,
		},
		{
			id: 'current-page',
			title: 'Current page',
			value: {
				name: route.name?.toString(),
				path: route.path,
				title: title.value,
				description: description.value,
			},
		},
	];
}));
</script>

<template>
	<slot />
</template>
